__turbopack_context__.v({
  "grayscale": "NormalImage-module-scss-module__l9_5_a__grayscale",
  "wrapper": "NormalImage-module-scss-module__l9_5_a__wrapper",
});
